import { render, staticRenderFns } from "./TranslationStep.vue?vue&type=template&id=05c7a1ec&scoped=true&"
import script from "./TranslationStep.vue?vue&type=script&lang=js&"
export * from "./TranslationStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c7a1ec",
  null
  
)

export default component.exports